import {
  ConsultaSeguimentoPergunta02IgnoraEnum,
  ConsultaSeguimentoPergunta02Model,
  ConsultaSeguimentoPergunta02ResultadoExameEnum,
} from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/consulta-seguimento/perguntas/consulta-seguimento-pergunta-02/model-consultaSeguimentoPergunta02'
import { MchatRfAplicacaoQueryModel } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/model-mChatRf'
import { booleanToSimNaoEnum } from 'components/form'
import { MChatPerguntaEnum, MChatPerguntaOpcaoEnum } from 'graphql/types.generated'

import { HISTORICO_MCHAT_CALCULATION_STATUS } from '../utils-HistoricoMchatRf'

interface HistoricoMChatRfPergunta02Model {
  ignoraSons: MchatRfAplicacaoQueryModel | undefined
  ignoraPessoas: MchatRfAplicacaoQueryModel | undefined
  fezExame: MchatRfAplicacaoQueryModel | undefined
  resultadoExame: MchatRfAplicacaoQueryModel | undefined
  model: ConsultaSeguimentoPergunta02Model
}

export const convertAplicacaoPergunta02 = (
  aplicacoes: ReadonlyArray<MchatRfAplicacaoQueryModel>
): HistoricoMChatRfPergunta02Model | null => {
  const ignoraSons = aplicacoes.find((aplicacao) => aplicacao.pergunta === MChatPerguntaEnum.PERGUNTA_02_01)
  const ignoraPessoas = aplicacoes.find((aplicacao) => aplicacao.pergunta === MChatPerguntaEnum.PERGUNTA_02_02)
  const fezExame = aplicacoes.find((aplicacao) => aplicacao.pergunta === MChatPerguntaEnum.PERGUNTA_02_03)
  const resultadoExame = aplicacoes.find((aplicacao) => aplicacao.pergunta === MChatPerguntaEnum.PERGUNTA_02_04)

  if (ignoraSons === undefined && ignoraPessoas === undefined) return null

  return {
    ignoraSons,
    ignoraPessoas,
    fezExame,
    resultadoExame,
    model: {
      status: HISTORICO_MCHAT_CALCULATION_STATUS,
      PERGUNTA_02_IGNORA: {
        [ConsultaSeguimentoPergunta02IgnoraEnum.IGNORA_SONS]: booleanToSimNaoEnum(ignoraSons?.stPassou),
        [ConsultaSeguimentoPergunta02IgnoraEnum.IGNORA_PESSOAS]: booleanToSimNaoEnum(ignoraPessoas?.stPassou),
      },
      PERGUNTA_02_FEZ_EXAME: booleanToSimNaoEnum(fezExame?.stPassou),
      PERGUNTA_02_RESULTADO_EXAME: convertResultadoExameToModel(resultadoExame?.perguntaOpcao),
    },
  }
}

const convertResultadoExameToModel = (
  resultadoExame: MChatPerguntaOpcaoEnum | null | undefined
): ConsultaSeguimentoPergunta02ResultadoExameEnum | undefined => {
  if (resultadoExame == null) return undefined

  return RESULTADO_EXAME_MODEL[resultadoExame]
}

const RESULTADO_EXAME_MODEL: Partial<Record<MChatPerguntaOpcaoEnum, ConsultaSeguimentoPergunta02ResultadoExameEnum>> = {
  [MChatPerguntaOpcaoEnum.AUDICAO_ABAIXO]: ConsultaSeguimentoPergunta02ResultadoExameEnum.AUDICAO_ABAIXO,
  [MChatPerguntaOpcaoEnum.AUDICAO_NORMAL]: ConsultaSeguimentoPergunta02ResultadoExameEnum.AUDICAO_NORMAL,
  [MChatPerguntaOpcaoEnum.NAO_DEFINITIVO]: ConsultaSeguimentoPergunta02ResultadoExameEnum.NAO_DEFINITIVO,
}
